import React, { useState } from 'react';
import { countryToFlag, getCountryFlagUrl } from '../../utils/countryFlag';

const CountryFlag = ({ code, size = 24 }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const url = getCountryFlagUrl(code);
  const emoji = countryToFlag(code);

  if (!code) return null;

  if (!url || imgFailed) {
    return emoji ? (
      <span className="country-flag country-flag-emoji" aria-hidden>
        {emoji}
      </span>
    ) : null;
  }

  return (
    <img
      className="country-flag country-flag-img"
      src={url}
      alt=""
      width={size}
      height={Math.round(size * 0.67)}
      loading="lazy"
      decoding="async"
      onError={() => setImgFailed(true)}
    />
  );
};

export default CountryFlag;
